<template>
	<div
		class="contents"
		role="status"
		aria-label="Načítání produktu"
	>
		<div class="flex items-start justify-center">
			<div class="skeleton-gradient w-full rem:max-h-[450px] aspect-square rounded-lg" />
		</div>
		<div class="flex flex-col gap-2 lg:gap-4 min-w-0">
			<div class="skeleton-gradient h-10 w-3/4 max-w-md rounded-lg" />
			<div class="skeleton-gradient h-5 w-1/3 rounded-lg hidden md:block" />
			<div class="skeleton-gradient h-5 w-48 rounded-lg hidden md:block" />
			<div class="w-full flex gap-4 justify-between items-start max-lg:flex-col">
				<div class="skeleton-gradient h-16 w-36 rounded-lg shrink-0" />
				<div class="skeleton-gradient h-24 w-full max-w-[21.4rem] rounded-lg" />
			</div>
			<div class="skeleton-gradient h-12 w-full rounded-xl" />
			<div class="skeleton-gradient h-20 w-full rounded-lg mt-2 lg:mt-4" />
			<div class="skeleton-gradient h-32 w-full rounded-lg" />
			<div class="skeleton-gradient h-32 w-full rounded-lg" />
			<div class="skeleton-gradient h-32 w-full rounded-lg" />
		</div>
	</div>
</template>
